import {reportBug} from '@packages/utilities/reporter';

// WARNGING!! Do not touch without very fine silk gloves. After patch 079 we
// have updated our Lightbox data stucture, since these settings are considered
// "legacy" we want to convert back to the old format here. We need to support
// this old format until we get Generic Bindings for dynamo.
//
// Once GB w Dynamo ships we can remove this support for the old format, unless
// we are unable to rewrite the lightbox site module.
const revert079LightboxImageMigrationLocally = (
  item: LightboxImage
): null | OldLightboxImage => {
  if (!item.val || !item.val.image) {
    // item should contain val.image
    const message = `Lightbox migration malformed data: ${JSON.stringify(
      item,
      null,
      2
    )}`;
    reportBug('WFDL:LightboxMigrationError', message, {
      team: 'core',
      priority: 'error',
      ticket: 'https://webflow.atlassian.net/browse/PLAT-764',
    });
    return null;
  }
  const {_id, fileSize, height, origFileName, url, width} = item.val.image;
  if (item.val.caption) {
    return {
      _id,
      origFileName,
      fileName: origFileName,
      fileSize,
      height,
      url,
      width,
      caption: item.val.caption,
      type: 'image',
    };
  }
  return {
    _id,
    origFileName,
    fileName: origFileName,
    fileSize,
    height,
    url,
    width,
    type: 'image',
  };
};
const revert079LightboxVideoMigrationLocally = (
  item: LightboxVideo
): null | OldLightboxVideo => {
  if (!item.val || !item.val.embed) {
    // item should contain val.embed
    const message = `Lightbox migration malformed data: ${JSON.stringify(
      item,
      null,
      2
    )}`;
    reportBug('WFDL:SelectUnknownProp', message, {
      team: 'core',
      priority: 'error',
      ticket: 'https://webflow.atlassian.net/browse/PLAT-764',
    });
    return null;
  }
  if (!item.val.embed.meta) {
    // Empty video links are not supported in the old lightbox settings
    return null;
  }
  const {html, height, thumb, width} = item.val.embed.meta;
  const url = item.val.embed.url;
  return {
    url,
    originalUrl: url,
    width,
    height,
    thumbnailUrl: thumb.url,
    html,
    type: 'video',
  };
};

type LightboxVideo = {
  tag: 'Video';
  val: {
    embed: {
      meta: {
        height: number;
        html: string;
        thumb: {
          url: string;
        };
        url: string;
        width: number;
      };
      url: string;
      type: 'video';
    };
  };
};
type LightboxImage = {
  tag: 'Image';
  val: {
    image: {
      fileName: string;
      fileSize: number;
      height: number;
      origFileName: string;
      type: 'image';
      url: string;
      width: number;
      _id: string;
    };
    caption: string;
  };
};
type LightboxItemData = LightboxImage | LightboxVideo;

type NewLightboxJson = {
  items: Array<LightboxItemData>;
  group: string;
};

type OldLightboxVideo = {
  type: 'video';
  originalUrl: string;
  url: string;
  html: string;
  thumbnailUrl: string;
  width: number;
  height: number;
};
type OldLightboxImage = {
  type: 'image';
  _id: string;
  fileName: string;
  origFileName: string;
  width: number;
  height: number;
  fileSize: number;
  url: string;
  caption?: string;
};
type OldLightboxItemData = OldLightboxImage | OldLightboxVideo;
type OldLightboxJson = {
  items: Array<OldLightboxItemData>;
  group: string;
};

export const revert079DataMigrationLocally = (
  json: NewLightboxJson
): OldLightboxJson => {
  return {
    items: json.items.reduce<Array<any>>((acc, item) => {
      let newItem;
      if (item.tag === 'Image') {
        newItem = revert079LightboxImageMigrationLocally(item);
      }
      if (item.tag === 'Video') {
        newItem = revert079LightboxVideoMigrationLocally(item);
      }
      if (newItem) {
        acc.push(newItem);
      }
      return acc;
    }, []),
    group: json.group,
  };
};
